import { useContext, useState, useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useWalletApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const getAllWallet = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const searchParam = query.search && String(query.search).trim() !== '' ? query.search : undefined;
        // Coerce values to API-allowed enums
        const allowedSortBy = new Set([
          'customerName',
          'customerEmail',
          'availableWalletBalance',
          'lastTransactionDate',
          'totalTransactions',
          'customerStatus',
        ]);
        const sortBy = allowedSortBy.has(query.sortBy) ? query.sortBy : 'customerName';
        const sortOrder = query.sortOrder === 'desc' ? 'desc' : 'asc';
        // getCustomersWithWalletDetails(page, limit, search?, sortBy?, sortOrder?, customerStatus?, transactionType?, dateFrom?, dateTo?, transactionLimit?)
        const response = await api.getCustomersWithWalletDetails(
          query.page,
          query.limit,
          searchParam,
          sortBy,
          sortOrder,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const updateWallet = useCallback(
    async (payload: {
      userId: string;
      amount: number;
      type: 'credit' | 'debit';
      description?: string;
      walletId?: string;
      paymentMethod?: string;
    }) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.updateWallet(payload as any);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );


  return {
    getAllWallet,
    updateWallet,
    loading,
    error,
  };
};
